import DesDownloadViewModel from 'viewmodel/DesDownloadViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesDownload extends DesBaseCatalogAcc {
    constructor() {
        super(DesDownloadViewModel);
    }

    get item() {
        return this.getAttribute('item');
    }
    get containerType() {
        return this.getAttribute('container-type') || this.getAttribute('containertype');
    }
    get provider() {
        return this.getAttribute('provider');
    }

    getProps() {
        return {
            item: this.item,
            containertype: this.containerType,
            provider: this.provider,
            catalogspaceid: this.catalogspaceId
        };
    }

    static get observedAttributes() {
        return [...DesBaseCatalogAcc.observedAttributes, 'containertype', 'container-type',
            'item', 'provider'];
    }
}

if (!window.customElements.get('des-download')) {
    window.customElements.define('des-download', DesDownload);
}
